export class UsuarioViewModel {
  id!: string;
  email: string | undefined;
  password: string | undefined;
  confirmPassword: string | undefined;
  name: string | undefined;
   cpf:string | undefined;
   birthDate?:string ;
  lockoutEnabled?:boolean;
  rolesName?: Array<string> = [];
}
 